import React from 'react';
import { reportError } from '../../hooks/useTelemetry';

/**
 * ChartErrorBoundary — Prevents a failed chart/section from blanking the page.
 * LAT-22: Error boundaries for chart sections.
 */
export default class ChartErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Chart section error:', error, errorInfo);
    // IDI-303: report to telemetry so a chart crash reaches an operator alert
    // instead of only a browser console nobody is watching.
    reportError('ChartErrorBoundary', error, { componentStack: errorInfo?.componentStack?.slice(0, 1000) });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '24px 16px',
          textAlign: 'center',
          background: 'var(--neutral-50)',
          border: '1px solid var(--neutral-200)',
          borderRadius: 3,
        }}>
          <p style={{
            margin: 0,
            fontSize: 14,
            color: 'var(--color-text-muted)',
          }}>
            {this.props.fallbackMessage || 'This section encountered an error'}
          </p>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              marginTop: 8,
              padding: '6px 12px',
              border: '1px solid var(--color-border)',
              borderRadius: 3,
              background: 'var(--color-surface)',
              fontSize: 12,
              cursor: 'pointer',
            }}
          >
            Retry
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
